<i18n>
{
  "en": {
    "notProductRelated": "No product assigned",
    "propagateConflict": "Spreading will also modify other restaurant products that you do not have access to."
  },
  "es": {
    "notProductRelated": "No hay ningun producto asignado",
    "propagateConflict":  "Al propagar se modificaran tambien otros productos de restaurantes que no tienes acceso"
  }
}
</i18n>
<template>
  <v-dialog @click:outside="onCancel" v-model="visible" persistent max-width="600px">
    <div v-if="productMaster">
      <div v-if="isLoading">
        <dynameat-spinner/>
        <p class="text-center">{{ title }}</p>
      </div>
      <transition name="fade">
        <v-card v-if="!isLoading && productMaster" class="px-5 py-4">
          <v-card-title class="headline pa-0 mb-1">{{ title }}</v-card-title>
          <v-card-text class="pa-0 mb-5">
            <div>{{ description }}</div>
            <v-list v-if="productsFiltered.length > 0" lines="ones">
              <v-list-item
                v-for="product in productsFiltered"
                :key="product.name"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ getCombinatedNameProduct(product) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div class="mt-2 red--text" v-if="productsFiltered.length !== productMaster.products.length">{{$t('propagateConflict')}}</div>
            <b><div class="ml-3" v-if="productsFiltered.length === 0">{{$t('notProductRelated')}}</div></b>
          </v-card-text>
          <dynameat-modal-buttons @cancel="onCancel" @confirm="onConfirm"
                                  :confirmText="confirmText" :cancelText="cancelText"/>
        </v-card>
      </transition>
    </div>
  </v-dialog>
</template>

<script>

import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import DynameatSpinner from '@dynameat/components/DynameatSpinner';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';
import { ProductMaster } from '../models/productMaster';

@Component
@Components({ DynameatSpinner, DynameatModalButtons })
@MapGetters(['pointOfSaleList'])
export default class ProductMasterPropagateModal extends Vue {
  @Prop({ type: String, default: '' }) title;

  @Prop({ type: String, default: '' }) description;

  @Prop({ Boolean, default: false }) isLoading;

  @Prop({ type: String, default() { return this.$t('cancel'); } }) cancelText;

  @Prop({ type: String, default() { return this.$t('confirm'); } }) confirmText;

  @Prop({ type: Boolean, default: false }) visible;

  @Prop({ type: ProductMaster, default: null }) productMaster;

  onCancel() {
    if (!this.isLoading) this.$emit('cancel');
  }

  get posNameByGuid() {
    const pos = {};
    this.pointOfSaleList.forEach((pointOfSale) => {
      pos[pointOfSale.guid] = pointOfSale.name;
    });
    return pos;
  }

  get posArray() {
    return this.pointOfSaleList.map((pos) => pos.guid);
  }

  get productsFiltered() {
    return this.productMaster.products.filter((product) => this.posArray.includes(product.point_of_sale_guid));
  }

  getCombinatedNameProduct(product) {
    return `${product.name} - ${this.posNameByGuid[product.point_of_sale_guid]}`;
  }

  onConfirm() {
    this.$emit('confirm');
  }
}
</script>

<style>
.v-dialog--active {
  background: white;
}
</style>

<style scoped>
.headline {
  word-break: break-word;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
